(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-folder', {
            parent: 'entity',
            url: '/handbook-folder?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookFolder.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-folder/handbook-folders.html',
                    controller: 'HandbookFolderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookFolder');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-folder-detail', {
            parent: 'handbook-folder',
            url: '/handbook-folder/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookFolder.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-folder/handbook-folder-detail.html',
                    controller: 'HandbookFolderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookFolder');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookFolder', function($stateParams, HandbookFolder) {
                    return HandbookFolder.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-folder',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-folder-detail.edit', {
            parent: 'handbook-folder-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-folder/handbook-folder-dialog.html',
                    controller: 'HandbookFolderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookFolder', function(HandbookFolder) {
                            return HandbookFolder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-folder.new', {
            parent: 'handbook-folder',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-folder/handbook-folder-dialog.html',
                    controller: 'HandbookFolderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-folder', null, { reload: 'handbook-folder' });
                }, function() {
                    $state.go('handbook-folder');
                });
            }]
        })
        .state('handbook-folder.edit', {
            parent: 'handbook-folder',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-folder/handbook-folder-dialog.html',
                    controller: 'HandbookFolderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookFolder', function(HandbookFolder) {
                            return HandbookFolder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-folder', null, { reload: 'handbook-folder' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-folder.delete', {
            parent: 'handbook-folder',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-folder/handbook-folder-delete-dialog.html',
                    controller: 'HandbookFolderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookFolder', function(HandbookFolder) {
                            return HandbookFolder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-folder', null, { reload: 'handbook-folder' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
